export default [
    "22.4 31.2",
    '<path fill="none" stroke="var(--ci-primary-color, currentColor)" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" d="M7,2.1c0.1,0.3,0.4,0.5,0.6,0.6c0.3,0.2,0.7,0.2,1.5,0.2h4.1c0.8,0,1.2,0,1.5-0.2c0.3-0.1,0.5-0.4,0.6-0.6\n' +
    'M1.5,25.9l11.4-11.4c0.4-0.4,0.6-0.6,0.8-0.7c0.2-0.1,0.4-0.1,0.6,0c0.2,0.1,0.4,0.3,0.8,0.7l5.9,5.9 M5.7,30.2h11.1\n' +
    'c1.6,0,2.5,0,3.1-0.3c0.5-0.3,1-0.7,1.3-1.3c0.3-0.6,0.3-1.4,0.3-3.1V5.7c0-1.6,0-2.5-0.3-3.1c-0.3-0.5-0.7-1-1.3-1.3\n' +
    'C19.2,1,18.4,1,16.8,1H5.7C4,1,3.2,1,2.6,1.3C2,1.6,1.6,2,1.3,2.6C1,3.2,1,4,1,5.7v19.8c0,1.6,0,2.5,0.3,3.1c0.3,0.5,0.7,1,1.3,1.3\n' +
    'C3.2,30.2,4,30.2,5.7,30.2z M8.5,11.9c0,1.1-0.9,2-2,2s-2-0.9-2-2s0.9-2,2-2S8.5,10.8,8.5,11.9z"/>'
]

